import { useContext } from 'react';
import { UIHelperContext } from '../context/UIHelperContext';

/**
 * Hook to access UIHelper context
 * Separated from main hook to avoid circular dependencies
 */
export default function useUIHelperContext() {
  const context = useContext(UIHelperContext);
  if (!context) {
    throw new Error('useUIHelperContext must be used within a UIHelperProvider');
  }
  return context;
}
